/**
 * All owner-web copy, Indonesian only (D22). One module, so a later translation is a data change.
 * API error codes map to plain words here; the API's technical `detail` is never shown (§6.3).
 */
export const t = {
  appName: 'GammaPOS',
  loading: 'Memuat…',

  loginTitle: 'Masuk',
  phone: 'Nomor HP',
  password: 'Kata sandi',
  newPasswordLabel: 'Kata sandi (min. 8 karakter)',
  confirmPassword: 'Ulangi kata sandi',
  showPassword: 'Tampilkan',
  hidePassword: 'Sembunyikan',
  passwordMismatch: 'Kata sandi tidak sama. Ketik ulang.',
  loginButton: 'Masuk',
  noAccount: 'Belum punya akun? Daftar dengan kode undangan',
  haveAccount: 'Sudah punya akun? Masuk',

  signupTitle: 'Daftar',
  inviteCode: 'Kode undangan',
  ownerName: 'Nama Anda',
  businessName: 'Nama usaha',
  outletName: 'Nama outlet',
  outletCode: 'Kode outlet (untuk nomor struk, mis. SBY01)',
  timezone: 'Zona waktu',
  signupButton: 'Daftar',
  businessType: 'Jenis usaha',
  businessServices: 'Jasa',
  businessServicesHint: 'barbershop, salon, cuci kendaraan',
  businessFood: 'Makanan & minuman',
  businessFoodHint: 'warung, bakmi, kafe, kedai',

  changePasswordTitle: 'Ganti kata sandi',
  changePasswordBody: 'Kata sandi Anda baru diatur ulang oleh tim Alfacode. Buat kata sandi baru dulu.',
  currentPassword: 'Kata sandi sementara',
  newPassword: 'Kata sandi baru (min. 8 karakter)',
  save: 'Simpan',

  navSubscription: 'Langganan',
  groupSummary: 'Ringkasan',
  groupManage: 'Kelola',
  groupAccount: 'Akun',
  menuMain: 'Menu utama',
  menuBottom: 'Menu',
  accountMenu: 'Menu akun',
  skipToContent: 'Langsung ke isi halaman',
  navHome: 'Laporan',
  navSales: 'Transaksi',
  navData: 'Layanan & Staf',
  navDevices: 'HP Kasir',
  navSettings: 'Pengaturan',
  logout: 'Keluar',

  // ---------- report (P4-05/06)
  today: 'Hari ini',
  yesterday: 'Kemarin',
  last7: '7 hari',
  thisMonth: 'Bulan ini',
  netSales: 'Penjualan bersih',
  salesCount: (n: number) => `${n} transaksi`,
  discountTotal: (v: string) => `diskon ${v}`,
  voided: (n: number, v: string) => `${n} dibatalkan (${v})`,
  noSales: 'Belum ada penjualan di periode ini.',
  noSalesBody: 'Transaksi muncul di sini begitu HP kasir mengirimnya. Cek status HP kasir di bawah.',
  staffCommission: 'Komisi staf',
  commissionNote: 'Dihitung dari harga sebelum diskon. Transaksi yang dibatalkan tidak dihitung.',
  noStaff: 'Tanpa staf',
  services: (n: number) => `${n} layanan`,
  noCommission: 'Tanpa komisi',
  byMethod: 'Cara bayar',
  byItem: 'Layanan & produk',
  sold: (n: number) => `${n} terjual`,
  byDay: 'Per hari',
  cashTitle: 'Kas per sesi',
  cashOpen: 'Masih buka',
  cashExpected: 'Seharusnya',
  cashActual: 'Dihitung',
  cashDiff: 'Selisih',
  cashLine: (open: string, sales: string, inOut: string) => `Awal ${open} · tunai ${sales} · masuk/keluar ${inOut}`,
  phonesTitle: 'HP kasir',
  phoneLine: (letter: string) => `HP ${letter}`,
  phoneRejected: (n: number) => `${n} transaksi ditolak server — hubungi tim Alfacode`,
  exportTitle: 'Unduh laporan (CSV)',
  exportNote: 'File bisa dibuka di Excel dan Google Sheets.',
  exportSales: 'Transaksi',
  exportItems: 'Rincian layanan',
  exportCommission: 'Komisi staf',
  exportCash: 'Kas',
  conflictBanner: (n: number) => `${n} perubahan dari HP kasir tidak dipakai karena sudah Anda ubah di web.`,
  seeDetail: 'Lihat',
  methods: { cash: 'Tunai', qris: 'QRIS', transfer: 'Transfer', other: 'Lainnya' } as Record<string, string>,

  // ---------- transactions
  salesTitle: 'Transaksi',
  searchReceipt: 'Cari nomor struk',
  loadMore: 'Muat lagi',
  voidedBadge: 'Dibatalkan',
  cashier: 'Kasir',
  back: 'Kembali',
  subtotal: 'Subtotal',
  discount: 'Diskon',
  total: 'Total',
  by: (name: string) => `oleh ${name}`,
  commission: 'komisi',
  voidInfo: (by: string, reason: string) => `Dibatalkan oleh ${by}: ${reason}`,
  receivedAt: 'Diterima server',

  // ---------- master data (P4-08)
  dataTitle: 'Layanan & Staf',
  tabItems: 'Layanan & produk',
  tabStaff: 'Staf',
  tabRules: 'Komisi',
  add: 'Tambah',
  edit: 'Ubah',
  cancel: 'Batal',
  name: 'Nama',
  type: 'Jenis',
  service: 'Layanan',
  product: 'Produk',
  category: 'Kategori (boleh kosong)',
  price: 'Harga',
  cost: 'Modal (boleh kosong)',
  active: 'Aktif',
  inactive: 'Nonaktif',
  ruleFor: 'Layanan',
  ruleStaff: 'Staf',
  ruleAllStaff: 'Semua staf',
  ruleType: 'Jenis komisi',
  ruleFixed: 'Rupiah per layanan',
  rulePercent: 'Persen dari harga',
  ruleRate: 'Besar komisi',
  ruleRatePercent: 'Persen (mis. 40 atau 12,5)',
  noItems: 'Belum ada layanan. Tambahkan di sini atau di HP kasir.',
  noStaffYet: 'Belum ada staf.',
  noRules: 'Belum ada aturan komisi.',
  syncNote: 'Perubahan dikirim ke HP kasir saat HP itu sinkron berikutnya.',
  conflictsTitle: 'Perubahan dari HP kasir yang tidak dipakai',
  conflictLine: (field: string, name: string, device: string, server: string) =>
    `${field} · ${name}: HP kasir mengubah ke ${device}, yang dipakai ${server} (dari web).`,
  markSeen: 'Tandai sudah dibaca',
  fields: {
    price: 'Harga',
    name: 'Nama',
    cost: 'Modal',
    category: 'Kategori',
    item_type: 'Jenis',
    active: 'Status',
    rate: 'Besar komisi',
    rule_type: 'Jenis komisi',
    role: 'Peran',
    pin_hash: 'PIN',
    pin_salt: 'PIN',
  } as Record<string, string>,

  // ---------- subscription (P6-10)
  subTitle: 'Langganan',
  stateTrial: (days: number) => `Masa percobaan: ${days} hari lagi`,
  stateActive: (days: number) => `Langganan aktif: ${days} hari lagi`,
  stateGrace: (days: number) => `Langganan berakhir ${days} hari lalu. Laporan masih bisa dibuka sampai masa tenggang habis.`,
  stateExpired: 'Langganan berakhir. Laporan dan unduhan CSV dinonaktifkan. Mencatat transaksi di HP kasir tetap berjalan, dan semua data Anda tetap bisa diunduh.',
  bannerTrialEnding: (days: number) => `Masa percobaan tinggal ${days} hari.`,
  bannerGrace: 'Langganan sudah berakhir. Perpanjang supaya laporan tetap bisa dibuka.',
  bannerExpired: 'Langganan berakhir, laporan dinonaktifkan.',
  bannerAction: 'Kelola langganan',
  validUntil: (d: string) => `Berlaku sampai ${d}`,
  choosePlan: 'Pilih paket',
  planLine: (months: number, days: number) => `${months} bulan · ${days} hari`,
  monthNote: 'Satu bulan dihitung 30 hari. Waktu langganan ditambahkan di atas sisa waktu Anda.',
  pay: 'Bayar',
  paying: 'Membuka pembayaran…',
  checkoutOff: 'Pembayaran online belum aktif. Hubungi tim Alfacode untuk memperpanjang.',
  waitingPayment: 'Menunggu konfirmasi pembayaran…',
  waitingHint: 'Biasanya beberapa detik. Halaman ini memeriksa sendiri; Anda tidak perlu memuat ulang.',
  paidOk: (d: string) => `Pembayaran diterima. Langganan aktif sampai ${d}.`,
  payFailed: 'Pembayaran tidak berhasil atau kedaluwarsa. Anda bisa memilih paket lagi.',
  payRefunded: 'Pembayaran ini sudah dikembalikan.',
  openPayment: 'Lanjutkan pembayaran',
  orders: 'Riwayat pembayaran',
  orderStatus: { pending: 'Menunggu', paid: 'Lunas', failed: 'Gagal', expired: 'Kedaluwarsa', refunded: 'Dikembalikan' } as Record<string, string>,
  voucherTitle: 'Punya kode voucher?',
  voucherLabel: 'Kode voucher',
  voucherRedeem: 'Pakai voucher',
  voucherOk: (days: number) => `Voucher dipakai: ${days} hari ditambahkan.`,
  reportsLocked: 'Laporan dinonaktifkan karena langganan berakhir.',
  reportsLockedBody: 'Data Anda tetap aman dan HP kasir tetap mencatat transaksi. Perpanjang langganan untuk membuka laporan lagi.',

  // ---------- history and data (P4-12, C5)
  historyTitle: 'Riwayat perubahan',
  historySub: 'Siapa mengubah apa dan kapan, dari yang terbaru.',
  historyFilter: 'Jenis perubahan',
  historyAll: 'Semua',
  historyFilterEmpty: 'Tidak ada perubahan untuk jenis ini.',
  historyLimit: 'Menampilkan 500 perubahan terbaru.',
  historyLinkHint: 'Siapa mengubah harga, staf, dan pengaturan',
  colWhen: 'Waktu',
  colWhat: 'Kegiatan',
  colBy: 'Oleh',
  pagination: 'Halaman riwayat',
  previous: 'Sebelumnya',
  next: 'Berikutnya',
  pageNumber: (n: number) => `Halaman ${n}`,
  showing: (from: number, to: number, total: number) => `Menampilkan ${from}-${to} dari ${total}`,
  historyEmpty: 'Belum ada perubahan tercatat.',
  rawExportTitle: 'Semua data Anda',
  rawExportBody: 'Unduh semua transaksi, layanan, staf, dan aturan komisi dalam satu file zip. Selalu tersedia.',
  rawExportButton: 'Unduh semua data',

  devicesTitle: 'HP Kasir',
  devicesEmpty: 'Belum ada HP kasir. Buat kode aktivasi, lalu ketik kodenya di aplikasi GammaPOS di HP kasir.',
  deviceActive: 'Aktif',
  deviceRevoked: 'Diganti',
  lastSync: 'Terakhir sinkron',
  never: 'Belum pernah',
  newCode: 'Buat kode aktivasi',
  replaceCode: 'Ganti HP kasir',
  pendingReport: (n: number, when: string) =>
    n === 0 ? `Semua transaksi sudah terkirim (dilaporkan ${when})` : `${n} transaksi belum terkirim (dilaporkan ${when})`,
  pendingUnknown: 'Jumlah transaksi yang belum terkirim belum dilaporkan HP ini.',
  replaceSafe: 'HP lama baru saja melaporkan semua transaksinya sudah terkirim. HP lama berhenti begitu HP baru diaktifkan.',
  replaceNotSafeTitle: 'HP lama mungkin masih menyimpan transaksi yang belum terkirim',
  replaceNotSafe: (receipt: string | null, when: string) =>
    `Transaksi setelah ${receipt ?? 'struk pertama'} di HP lama belum terkirim dan tidak akan masuk laporan. ` +
    `Terakhir sinkron: ${when}. HP lama langsung dihentikan.`,
  replaceTip:
    'Kalau HP lama masih bisa dinyalakan: buka aplikasi, tunggu sampai "Semua transaksi sudah aman", lalu muat ulang halaman ini.',
  replaceAck: 'Saya mengerti, ganti HP sekarang',
  replaceRecover: 'Transaksi di HP lama masih bisa diselamatkan lewat ekspor darurat. Hubungi tim Alfacode.',
  refresh: 'Muat ulang',
  codeValidUntil: (time: string) => `Ketik kode ini di HP kasir. Berlaku sampai ${time}.`,

  settingsTitle: 'Pengaturan',
  settingsSub: 'Data outlet, logo struk, dan pengaturan kasir.',
  settingsMore: 'Pengaturan lainnya',
  outletInfo: 'Info outlet',
  outletInfoHint: 'Dicetak di struk pelanggan.',
  subLinkHint: 'Masa langganan dan perpanjangan',
  devicesSub: 'HP yang dipakai kasir di outlet ini.',
  address: 'Alamat (dicetak di struk)',
  outletPhone: 'Nomor telepon (dicetak di struk)',
  receiptFooter: 'Pesan di bawah struk',
  saved: 'Tersimpan',

  // Dashboard and lists
  homeSub: 'Ringkasan penjualan outlet Anda.',
  salesSub: 'Semua transaksi dari HP kasir. Ketuk satu untuk melihat rinciannya.',
  statCount: 'Transaksi',
  statDiscount: 'Diskon',
  statVoid: 'Dibatalkan',
  showAll: (n: number) => `Lihat semua (${n})`,
  showLess: 'Ringkas',
  colReceipt: 'No. struk',
  colCashier: 'Kasir',
  colOrder: 'Pesanan',
  colMethod: 'Pembayaran',
  colTotal: 'Total',
  salesShown: (n: number) => `${n} transaksi ditampilkan`,

  // Receipt logo
  logoTitle: 'Logo struk',
  logoBody: 'Dicetak di bagian atas struk. Pakai gambar sederhana: warna dan foto diubah menjadi titik hitam putih.',
  logoPick: 'Pilih gambar',
  logoChange: 'Ganti gambar',
  logoModeLabel: 'Hasil cetak',
  logoModeSharp: 'Tegas (logo, tulisan)',
  logoModePhoto: 'Foto (titik halus)',
  logoInvert: 'Balik hitam dan putih',
  logoPreview: 'Pratinjau cetak',
  logoSize: (w: number, h: number) => `${w} × ${h} titik`,
  logoSave: 'Simpan logo',
  logoRemove: 'Hapus logo',
  logoSaved: 'Logo tersimpan. HP kasir mencetaknya setelah sinkron berikutnya.',
  logoRemoved: 'Logo dihapus. Struk berikutnya dicetak tanpa logo setelah HP kasir sinkron.',
  logoNone: 'Belum ada logo. Struk dicetak dengan nama usaha saja.',
  logoUnreadable: 'Gambar tidak bisa dibuka. Pakai file PNG, JPG, atau WebP.',
  logoTooBig: 'File terlalu besar. Pakai gambar di bawah 5 MB.',
  logoBlank: 'Tidak ada titik hitam yang bisa dicetak. Coba mode Foto, atau balik hitam dan putih.',

  // Reports (F&B lite)
  taxLine: 'Pajak (PB1)',
  serviceLine: 'Service',
  takeawayFeeLine: 'Biaya bungkus',
  roundingLine: 'Pembulatan',
  inPrice: 'sudah di harga',
  orderTypeTitle: 'Makan di sini / Bungkus',
  dineIn: 'Makan di sini',
  takeaway: 'Bungkus',
  noOrderType: 'Tanpa jenis pesanan',
  tableLabel: (label: string) => `Meja ${label}`,
  itemNote: 'Catatan',

  // Cashier settings
  kasirLink: 'Pengaturan kasir',
  kasirLinkHint: 'Pajak, service, pembulatan, meja, catatan, struk dapur',
  kasirTitle: 'Pengaturan kasir',
  kasirSub: 'Pajak, service, pesanan, catatan dapur, dan cetak. Berlaku di semua HP kasir setelah sinkron.',
  subSub: 'Masa langganan Anda dan cara memperpanjang.',
  kasirBusinessSection: 'Jenis usaha',
  kasirBusinessNow: (type: string) => `Jenis usaha outlet ini: ${type}`,
  kasirApplyProfile: 'Terapkan pengaturan awal',
  kasirSwitchTo: (type: string) => `Ganti ke ${type}`,
  kasirApplyConfirmTitle: (type: string) => `Terapkan pengaturan awal ${type}?`,
  kasirApplyConfirmBody: 'Pengaturan berikut akan berubah. Pengaturan lain yang Anda ubah sendiri ikut kembali ke awal.',
  kasirApplyNothing: 'Pengaturan Anda sudah sama dengan pengaturan awal.',
  kasirApplyYes: 'Ya, terapkan',
  kasirApplyNo: 'Batal',
  kasirTaxSection: 'Pajak & service',
  kasirTaxEnabled: 'Pajak restoran (PB1)',
  kasirTaxRate: 'Tarif pajak (%)',
  kasirServiceEnabled: 'Service charge',
  kasirServiceRate: 'Tarif service (%)',
  kasirInclusive: 'Harga menu sudah termasuk pajak & service',
  kasirInclusiveHint: 'Struk menampilkan pajak dan service yang sudah ada di harga, tidak menambah total.',
  kasirRounding: 'Bulatkan total ke Rp 100',
  kasirRateInvalid: 'Isi tarif 0 sampai 25, mis. 10 atau 2,5.',
  kasirPreviewTitle: 'Contoh pesanan Rp 48.000',
  kasirPreview: (service: string, tax: string, rounding: string, total: string) =>
    `Service ${service} · PB1 ${tax} · Pembulatan ${rounding} · Total ${total}`,
  kasirOrderSection: 'Pesanan',
  kasirOrderType: 'Tanyakan makan di sini atau bungkus',
  kasirTakeawayFee: 'Biaya bungkus per pesanan (Rp, kosongkan jika tidak ada)',
  kasirTakeawayFeeInvalid: 'Biaya bungkus 0 sampai 100.000.',
  kasirTable: 'Catat nomor meja',
  kasirItemNotes: 'Catatan per menu (mis. tidak pedas)',
  kasirPresets: 'Catatan cepat',
  kasirPresetNew: 'Catatan baru',
  kasirPresetAdd: 'Tambah catatan',
  kasirPresetRemove: (p: string) => `Hapus catatan ${p}`,
  kasirPresetLimit: 'Paling banyak 10 catatan, masing-masing sampai 30 huruf.',
  kasirStaffSection: 'Staf',
  kasirStaffPerLine: 'Tanya siapa yang mengerjakan tiap layanan',
  kasirPrintSection: 'Cetak',
  kasirKitchen: 'Cetak struk dapur',
  kasirKitchenCopies: 'Jumlah lembar struk dapur',
  kasirReceiptNotes: 'Tampilkan catatan menu di struk pelanggan',
  kasirOpenBillSection: 'Bayar nanti (open bill)',
  kasirOpenBill: 'Izinkan pesanan dibayar nanti',
  kasirOpenBillHint:
    'Pesanan disimpan di HP kasir sampai dibayar. Pesanan yang belum dibayar tidak masuk laporan dan hanya ada di HP itu. Kalau HP hilang atau rusak, pesanan itu ikut hilang.',
  kasirSaved: 'Tersimpan. HP kasir memakai pengaturan baru setelah sinkron berikutnya.',
  kasirSave: 'Simpan pengaturan',
  kasirOn: 'aktif',
  kasirOff: 'mati',
  kasirFieldNames: {
    staff_per_line_enabled: 'Tanya staf per layanan',
    tax_enabled: 'Pajak',
    tax_rate_bps: 'Tarif pajak',
    service_enabled: 'Service charge',
    service_rate_bps: 'Tarif service',
    prices_include_tax: 'Harga sudah termasuk pajak',
    rounding_unit: 'Pembulatan Rp 100',
    order_type_enabled: 'Makan di sini / bungkus',
    takeaway_fee_amount: 'Biaya bungkus',
    table_number_enabled: 'Nomor meja',
    item_notes_enabled: 'Catatan per menu',
    note_presets: 'Catatan cepat',
    receipt_show_notes: 'Catatan di struk pelanggan',
    kitchen_ticket_enabled: 'Struk dapur',
    kitchen_ticket_copies: 'Lembar struk dapur',
    open_bill_enabled: 'Bayar nanti',
  } as Record<string, string>,
} as const

const errors: Record<string, string> = {
  invalid_credentials: 'Nomor HP atau kata sandi salah.',
  too_many_attempts: 'Terlalu banyak percobaan. Coba lagi dalam 15 menit.',
  invalid_invite: 'Kode undangan salah atau sudah dipakai.',
  phone_taken: 'Nomor HP ini sudah terdaftar. Silakan masuk.',
  invalid_phone: 'Nomor HP tidak dikenali. Gunakan nomor HP Indonesia, mis. 0812…',
  wrong_password: 'Kata sandi sementara salah.',
  invalid_request: 'Ada isian yang belum benar.',
  network: 'Tidak ada internet. Coba lagi.',
  subscription_required: 'Langganan berakhir. Perpanjang untuk membuka laporan.',
  voucher_invalid: 'Kode voucher tidak dikenali atau sudah kedaluwarsa.',
  voucher_used_up: 'Voucher ini sudah habis dipakai.',
  voucher_already_redeemed: 'Voucher ini sudah pernah Anda pakai.',
  payment_provider_unavailable: 'Layanan pembayaran sedang tidak bisa dihubungi. Coba lagi sebentar lagi.',
  billing_not_configured: 'Pembayaran online belum aktif. Hubungi tim Alfacode.',
  unknown_plan: 'Paket tidak dikenali. Muat ulang halaman.',
  version_conflict: 'Data ini baru saja diubah di tempat lain (HP kasir atau tab lain). Muat ulang, lalu ubah lagi.',
  rule_exists: 'Sudah ada aturan komisi aktif untuk layanan dan staf ini. Ubah aturan yang ada.',
  unknown_reference: 'Layanan atau staf itu tidak ditemukan. Muat ulang halaman.',
  rate_above_100_percent: 'Komisi persen tidak boleh lebih dari 100%.',
  unsent_not_acknowledged: 'Centang dulu pernyataan bahwa Anda mengerti transaksi HP lama bisa hilang.',
  invalid_range: 'Tanggal akhir sebelum tanggal awal.',
  range_too_long: 'Periode paling lama satu tahun.',
  no_logo: 'Belum ada logo.',
}

export function errorMessage(code: string): string {
  return errors[code] ?? 'Terjadi kesalahan. Coba lagi sebentar lagi.'
}
